import React from "react";
import AddIcon from "../../Assets/Icons/AddIcon.svg";
import { useNavigate } from "react-router-dom"

const CreateNewButton = ({ text, navigateTo, iconClassName = "", onClick }) => {
  const navigate = useNavigate();
  const handleClick = () => {
    if (typeof onClick === "function") {
      onClick();
      return;
    }
    if (navigateTo) {
      navigate(navigateTo);
    }
  }
  return (
    <div className="flex items-center w-[40%] justify-end">
      <button className="relative sm:w-[180px] lg:w-[210px] h-[38px] rounded-[5px] bg-[#00ADEF] sm:text-[12px] lg:text-[14px] font-[600] font-nunito text-[#FFFFFF] text-center pl-[1.25rem] pr-[0.75rem] whitespace-nowrap flex items-center justify-center" onClick={() => handleClick()}>
        <img
          src={AddIcon}
          className={`absolute left-[0.5rem] top-1/2 transform -translate-y-1/2 w-4 h-4 ${iconClassName}`}
          alt="add-new"
        />
        <span className="ml-4">{text}</span>
      </button>
    </div>
  );
};

export default CreateNewButton;
